import React from 'react';

/**
 * Internal links inside prerenderable blog markup. The SPA swaps in
 * react-router's <Link>; the build-time snapshot uses a plain anchor.
 */
export type LinkComponent = React.FC<{ to: string; className?: string; children: React.ReactNode }>;

export const AnchorLink: LinkComponent = ({ to, className, children }) => (
  <a href={to} className={className}>
    {children}
  </a>
);
